<template>
  <div class="modal-detalhes-auto">
    <v-dialog scrollable :value="show" @input="fechar" max-width="1140px">
      <div v-if="auto.numero_auto">
        <v-card>
          <v-card-title>Detalhes do auto: {{ auto.numero_auto }}</v-card-title>
          <v-divider></v-divider>
          <v-tabs
            v-model="tab"
            icons-and-text
            style="text-transform: uppercase;"
          >
            <v-tabs-slider></v-tabs-slider>

            <v-tab href="#geral">
              Geral
              <v-icon>bookmark</v-icon>
            </v-tab>

            <v-tab href="#imagens">
              Imagens
              <v-icon>image</v-icon>
            </v-tab>

            <v-tab href="#boletos">
              Boletos
              <v-icon>description</v-icon>
            </v-tab>

            <v-tab href="#timeline">
              Linha do Tempo
              <v-icon>explore</v-icon>
            </v-tab>

            <!-- 

            <v-tab href="#historicos">
              Históricos de Status
              <v-icon>history</v-icon>
            </v-tab>           

            <v-tab href="#erros">
              Retornos Detran
              <v-icon>description</v-icon>
            </v-tab> -->
          </v-tabs>

          <v-tabs-items
            class="overflow-y-auto"
            style="max-height: 600px;"
            v-model="tab"
          >
            <v-tab-item value="geral">
              <dados-gerais
                :auto="auto"
                :arquivo_na="arquivo_na"
                :arquivo_np="arquivo_np"
              />
            </v-tab-item>
            <v-tab-item value="imagens">
              <imagens :idAuto="idAuto" />
            </v-tab-item>
            <v-tab-item value="boletos">
              <boletos :idAuto="idAuto" />
            </v-tab-item>
            <v-tab-item value="timeline">
              <linha-do-tempo :idAuto="idAuto" />
            </v-tab-item>
          </v-tabs-items>

          <v-divider></v-divider>
          <v-card-actions class="justify-space-between px-4 py-4">
            <div>
              <v-btn
                outlined
                color="primary"
                class="mr-2"
                v-if="!auto.suv"
                @click="visualizarAit('ait')"
              >
                <v-icon left>mdi-file</v-icon>AIT
              </v-btn>
              <v-btn
                v-if="
                  !!permissoes.visualizar_na &&
                    (arquivo_na || auto.data_emissao_na) &&
                    !auto.sne_na
                "
                color="primary"
                class="mr-2"
                outlined
                @click="visualizarNotificacao(1)"
              >
                <v-icon left>mdi-file</v-icon>NA
              </v-btn>
              <v-btn
                v-if="
                  !!permissoes.visualizar_np &&
                    (arquivo_np || auto.data_emissao_np) &&
                    !auto.sne_np
                "
                color="primary"
                class="mr-2"
                outlined
                @click="visualizarNotificacao(2)"
              >
                <v-icon left>mdi-file</v-icon>NP
              </v-btn>
            </div>

            <v-btn color="primary" outlined @click="fechar">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </div>
      <div v-else>
        <v-overlay :value="true">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import DadosGerais from "@/components/Tabs/DadosGerais";
import Imagens from "@/components/Tabs/ImagensTab";
import Boletos from "@/components/Tabs/Boletos";
import LinhaDoTempo from "@/components/Tabs/LinhaDoTempo";
import urlApi from "@/routes/urlApi";

export default {
  name: "ModalDetalhesAuto",

  components: {
    DadosGerais,
    Imagens,
    Boletos,
    LinhaDoTempo,
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    idAuto: {
      type: Number,
      default: null,
    },
    permissoes: {
      type: Object,
      default: () => ({}),
    },
    overlay: {
      type: Boolean,
      default: false,
    },
    perfil: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      tab: null,
      auto: {},
      arquivo_na: null,
      arquivo_np: null,
    };
  },

  methods: {
    detalhesGeral() {
      this.$http.get(`${urlApi}/v2/autos/${this.idAuto}`).then((response) => {
        this.auto = response.data.auto;
        this.arquivo_na = this.getArquivoPostagemByName("NA");
        this.arquivo_np = this.getArquivoPostagemByName("NP");
      });
    },
    getArquivoPostagemByName(name) {
      if (this.auto && !this.auto.postagens) return false;

      return this.auto.postagens.find(
        (arquivo) =>
          !arquivo.cancelado &&
          arquivo.data_postagem &&
          arquivo.tipo.nome === name
      );
    },
    visualizarAit(tipoNotificacao) {
      const payload = { tipoNotificacao, id_auto: this.auto.id_auto };
      this.$emit("visualizar-notificacao", payload);
    },
    visualizarNotificacao(tipoNotificacao) {
      const payload = { auto: { ...this.auto }, tipoNotificacao };
      this.$emit("visualizar-nova-notificacao", payload);
    },
    fechar() {
      this.$emit("fechar");
    },
  },
  mounted() {
    this.detalhesGeral();
  },
};
</script>
